import AnimatedDetails from './animated-details';

class Accordion {

  /**
   * Add accordion functionality to given element.
   *
   * @param {HTMLElement} el Element to wrap.
   * @param {Object} options Accordion settings.
   */
  constructor(el, options = {}) {
    this.options = {
      animationDuration: 300,
      animationEasing: 'ease-out',
      allowMultipleOpen: true,
      ...options
    };
    this.element = el;

    const items = [];
    const details = el.querySelectorAll('details');
    details.forEach(detail => {
      items.push(new AnimatedDetails(detail, {
        animationDuration: this.options.animationDuration,
        animationEasing: this.options.animationEasing,
      }));

      // Close other items if only one is allowed to be open
      detail.addEventListener('toggle', (e) => {
        if (e.target.open && !this.options.allowMultipleOpen) {
          this.items.forEach(el => {
            if (el.details !== e.target) {
              el.toggle(false);
            }
          });
        }
      });
    });
    this.items = items;
  }

}

export default Accordion;
